import { Controller } from "@hotwired/stimulus"

// Şifre alanının yanındaki göz düğmesi: type'ı password ↔ text çevirir,
// iki ikonu (göster / gizle) değiştirir ve erişilebilirlik etiketini günceller.
// Sunucuya hiçbir şey gitmez; JS yüklenmezse alan sıradan şifre kutusu kalır.
export default class extends Controller {
  static targets = ["input", "button", "show", "hide"]
  static values = { showLabel: String, hideLabel: String }

  toggle() {
    const visible = this.inputTarget.type === "text"

    this.inputTarget.type = visible ? "password" : "text"
    // İkonlar <svg>: `.hidden` özelliği yalnız HTMLElement'te var, SVG'de expando kalır
    // ve hiçbir şey gizlenmez — ATTRIBUTE'u değiştir (CSS `[hidden]` ona bakar).
    this.showTarget.toggleAttribute("hidden", !visible)
    this.hideTarget.toggleAttribute("hidden", visible)
    this.buttonTarget.setAttribute("aria-pressed", String(!visible))
    this.buttonTarget.setAttribute("aria-label", visible ? this.showLabelValue : this.hideLabelValue)
    this.inputTarget.focus({ preventScroll: true })
  }
}
